module.exports = __webpack_public_path__ + "f4953a7acb01f1b2d04f2532b3f93cc8.pdf";